// extracted by mini-css-extract-plugin
export default {"flightWrapper":"styles_flightWrapper__70hQ5","infoRow":"styles_infoRow__GRMME","overview":"styles_overview__I13t3","lopaKey":"styles_lopaKey__7AR5C","event":"styles_event__zqDQm"};